import type { WorkspaceResponseV2 } from '@emma/api_client/types';
import { NetworkConfigTable } from '@/components/network_config/NetworkConfigTable';

type Props = {
  workspace: WorkspaceResponseV2;
};

export const WorkspaceNetworkConfigsSubPage = (props: Props) => {
  return <NetworkConfigTable workspaceId={props.workspace.id} />;
};
